import { Component, OnInit } from '@angular/core';
import { WidgetComponent } from '../../../dashboards/components/widget-component/widget-component';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/application-store';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'mojo-twitter',
  templateUrl: './twitter.component.html',
  styleUrls: ['./twitter.component.scss']
})
export class TwitterComponent extends WidgetComponent implements OnInit {

  constructor(
    protected readonly store: Store<ApplicationState>,
    protected readonly confirmationService: ConfirmationService
  ) {
    super(store, confirmationService);
  }

}
